import { openModal } from "action/modal/openModal";
import PAImage from "component/design-system/images/PAImage";
import PAText from "component/design-system/typography/PAText/PAText";
import { useDispatch } from "react-redux";
import { getRelativeImagePath } from "util/helper/getRelativeImagePath";
import styles from "./apparel-component.module.scss";

const shippingInfo = [
  {
    icon: "/images/shipping_icon.svg",
    title: "Free shipping on orders over $99",
    description: "shipping",
  },
  {
    icon: "/images/returns_icon.svg",
    title: "30 days from the shipping date to return",
    description: "returns",
  },
];

const ApparelShippingInfo = () => {
  const dispatch = useDispatch();

  const handleShippingClick = (description: string) => {
    dispatch(openModal("apparelShippingModal", {
      description,
    }));
  };

  return (
    <div className={styles.shipping_info_container}>
      {shippingInfo.map((info) => (
        <div key={info.title} className={styles.shipping_info}>
          <PAImage
            src={getRelativeImagePath(info.icon)}
            alt="Size Chart"
            width={25}
            height={25}
          />
          <PAText className={styles.shipping_title} onClick={() => handleShippingClick(info.description)}>
            {info.title}
          </PAText>
        </div>
      ))}
    </div>
  );
};

export default ApparelShippingInfo;
